<!-- Preview Mode -->
<div *ngIf="mode === 'preview'" [ngStyle]="getPreviewStyles()" class="prose max-w-none p-6 rounded-lg">
  <div *ngIf="getHeading()" class="mb-6">
    <h2 [style.color]="getHeadingColor()" [ngClass]="getTitlePositionClass()" class="text-3xl font-bold">{{ getHeading() }}</h2>
  </div>

  <!-- No Products Selected State -->
  <div *ngIf="!hasSelectedProducts()" class="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
    <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </svg>
    <h3 class="mt-2 text-sm font-medium text-gray-900">Geen producten geselecteerd</h3>
    <p class="mt-1 text-sm text-gray-500">Selecteer eerst producten in de sidebar om ze hier te tonen.</p>
  </div>

  <!-- Loading State -->
  <div *ngIf="hasSelectedProducts() && loading" class="flex justify-center items-center py-12">
    <div class="text-gray-400">Producten laden...</div>
  </div>

  <!-- Products Grid View -->
  <div *ngIf="hasSelectedProducts() && !loading && getViewType() === 'grid'" [ngClass]="getGridColumnsClass()" class="grid gap-6">
    <div *ngFor="let product of filteredProducts" class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow relative group">
      <!-- Remove Button -->
      <button
        *ngIf="product.id"
        (click)="onRemoveProduct(product.id, $event)"
        class="absolute top-2 right-2 z-10 p-1.5 rounded-md bg-red-500 text-white opacity-0 group-hover:opacity-100 hover:bg-red-600 transition-opacity"
        title="Product verwijderen">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div *ngIf="getProductImage(product)" class="aspect-w-16 aspect-h-9 bg-gray-200">
        <img [src]="getProductImage(product)" [alt]="getProductName(product)" class="w-full h-48 object-cover">
      </div>
      <div class="p-4">
        <h3 [style.color]="getTextColor()" class="text-lg font-semibold mb-2">{{ getProductName(product) }}</h3>
        <p *ngIf="getShowDescription()" [style.color]="getTextColor()" class="text-sm mb-3 line-clamp-2 opacity-80">
          {{ getProductDescription(product) }}
        </p>
        <div *ngIf="getShowPrice()" class="text-xl font-bold text-indigo-600">
          {{ formatPrice(getProductPrice(product)) }}
        </div>
      </div>
    </div>
  </div>

  <!-- Products List View -->
  <div *ngIf="hasSelectedProducts() && !loading && getViewType() === 'list'" class="space-y-4">
    <div *ngFor="let product of filteredProducts" class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow flex relative group">
      <!-- Remove Button -->
      <button
        *ngIf="product.id"
        (click)="onRemoveProduct(product.id, $event)"
        class="absolute top-2 right-2 z-10 p-1.5 rounded-md bg-red-500 text-white opacity-0 group-hover:opacity-100 hover:bg-red-600 transition-opacity"
        title="Product verwijderen">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div *ngIf="getProductImage(product)" class="w-32 h-32 flex-shrink-0">
        <img [src]="getProductImage(product)" [alt]="getProductName(product)" class="w-full h-full object-cover">
      </div>
      <div class="flex-1 p-4">
        <h3 [style.color]="getTextColor()" class="text-lg font-semibold mb-2">{{ getProductName(product) }}</h3>
        <p *ngIf="getShowDescription()" [style.color]="getTextColor()" class="text-sm mb-3 opacity-80">
          {{ getProductDescription(product) }}
        </p>
        <div *ngIf="getShowPrice()" class="text-xl font-bold text-indigo-600">
          {{ formatPrice(getProductPrice(product)) }}
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State (when products are selected but none found) -->
  <div *ngIf="hasSelectedProducts() && !loading && filteredProducts.length === 0" class="text-center py-12">
    <p class="text-gray-400">Geen producten gevonden</p>
  </div>
</div>

<!-- Edit Mode - No edit mode needed, styling is in sidebar -->
<div *ngIf="mode === 'edit'">
  <p class="text-sm text-gray-400">Gebruik de sidebar om de weergave en filters aan te passen.</p>
</div>
